"use client";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import HomePub from "./components/HomePub";
import { Navbar } from "./components/navbar";
import { ContactCTA } from "./components/cta";
import Footer from "./components/footer";
import Products from "@/components/company/products";
import Clients from "@/components/company/clients";


export default function Page() {
    return (
        <div>
            <Navbar />

            <div>
                <section className="bg-[url('/images/renewable-wind-turbine.jpg')] bg-no-repeat bg-center bg-cover">
                    <div className="bg-brandblue/90 w-full py-16">
                        <div className="max-w-7xl w-full px-5 mx-auto  prose tracking-wider" data-aos="fade-up">

                            <h1 className=" text-5xl max-w-4xl font-light text-white">
                                Unitrend supports{" "}
                                <i>
                                    <b>Decision Makers</b>
                                </i>{" "}
                                advancing data for better policy
                            </h1>

                            <h2 className="max-w-4xl mt-5 text-white font-extralight">
                                We drive change through unravelling data technologies to
                                achieve policy excellence.
                            </h2>

                        </div>
                    </div>
                </section>

                <HomePub />

                <div className="max-w-7xl w-full mx-auto mt-20 px-5">
                    <p className="text-center font-bold text-2xl mb-5 uppercase">
                        Produk kami
                    </p>

                    <p className="max-w-xl w-full mx-auto text-center text-sm text-slate-500 mb-10">
                        Kami menawarkan berbagai layanan yang dapat membantu anda dalam
                        melakukan riset secara lebih komprehensif dengan pendekatan analitis
                        yang terstruktur.
                    </p>

                    <Products />
                </div>

                <div className="my-20">
                    <h1 className="text-center text-3xl md:text-4xl font-light text-gray-500 mb-10">
                        Telah diliput oleh:
                    </h1>

                    <Clients />
                </div>

                <div className="mt-20">
                    <div className="flex justify-between items-center px-5 mb-10">
                        <p className="text-left font-black text-4xl uppercase text-brandblue">
                            Riset kami
                        </p>

                        <Link href={"/riset"}>
                            <Button variant={"link"} className="underline">
                                Lihat lebih banyak
                            </Button>
                        </Link>
                    </div>

                    <div className="font-bold tracking-wide text-4xl text-wrap text-center text-white">
                        <div className="grid grid-cols-1 lg:grid-cols-3">
                            <Link
                                href={"/riset/tren-ekonomi-indonesia"}
                                className="lg:col-span-2 h-96 relative flex items-center justify-center bg-[url('/images/sectors/kemiskinan.jpg')] bg-cover bg-no-repeat bg-center group cursor-pointer"
                            >
                                <div className="absolute inset-0 bg-red-400 opacity-50 group-hover:bg-black"></div>
                                <h2 className="relative z-10">
                                    Perkembangan Ekonomi Indonesia
                                </h2>
                            </Link>
                            <Link
                                href={"/riset/tren-sdgs-indonesia"}
                                className="h-96 relative flex items-center justify-center bg-[url('/images/sectors/kesehatan.jpg')] bg-cover bg-no-repeat bg-center group cursor-pointer"
                            >
                                <div className="absolute inset-0 bg-indigo-400 opacity-50 group-hover:bg-black"></div>
                                <h2 className="relative z-10">Perkembangan SDGs Indonesia</h2>
                            </Link>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-3">
                            <Link
                                href={"/riset/tren-ekonomi-indonesia"}
                                className="h-96 relative flex items-center justify-center bg-[url('/images/sectors/keuangan.jpg')] bg-cover bg-no-repeat bg-center group cursor-pointer"
                            >
                                <div className="absolute inset-0 bg-green-400 opacity-50 group-hover:bg-black"></div>
                                <h2 className="relative z-10">Perkembangan SDGs Indonesia</h2>
                            </Link>

                            <Link
                                href={"/riset/tren-fintech-indonesia"}
                                className="lg:col-span-2 h-96 relative flex items-center justify-center bg-[url('/images/sectors/mobile-payment.jpg')] bg-cover bg-no-repeat bg-center group cursor-pointer"
                            >
                                <div className="absolute inset-0 bg-blue-400 opacity-50 group-hover:bg-black"></div>
                                <h2 className="relative z-10">
                                    Perkembangan Platform Fintech Indonesia
                                </h2>
                            </Link>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-3">
                            {/* <Link
                href={"/riset/pantauan-pemilu-indonesia-2024"}
                className="h-96 relative flex items-center justify-center bg-[url('/images/sectors/ketimpangan.jpg')] bg-cover bg-no-repeat bg-center group cursor-pointer"
              >
                <div className="absolute inset-0 bg-yellow-400 opacity-50 group-hover:bg-black"></div>
                <h2 className="relative z-10">Tren Pemilu Indonesia 2024</h2>
              </Link> */}
                            {/* <Link
                href={"/riset/tren-ekonomi-indonesia"}
                className="h-96 relative flex items-center justify-center bg-[url('/images/sectors/keuangan.jpg')] bg-cover bg-no-repeat bg-center group cursor-pointer"
              >
                <div className="absolute inset-0 bg-pink-400 opacity-50 group-hover:bg-black"></div>
                <h2 className="relative z-10">Tren Politik Indonesia</h2>
              </Link> */}
                        </div>
                    </div>
                </div>
            </div>
            <ContactCTA />
            <Footer />
        </div>
    );
}
